/** Parse YYYY-MM-DD or ISO date string as local calendar date */
export const parseActivityDate = (dateString) => {
  if (!dateString) return null
  const datePart = String(dateString).split('T')[0]
  const [y, m, d] = datePart.split('-').map(Number)
  if (!y || !m || !d) return null
  return new Date(y, m - 1, d)
}

export const isActivityEnded = (activity) => {
  const end = parseActivityDate(activity?.end_date)
  if (!end) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  end.setHours(23, 59, 59, 999)
  return today > end
}

export const isActivityCompleted = (activity) =>
  activity?.status === 'completed' || activity?.status_display === 'Completed'

export const canModifyActivity = (activity) =>
  !isActivityCompleted(activity) && !isActivityEnded(activity)

/**
 * Progress from start_date → end_date (0–100).
 * Before start: 0%. After end: 100%.
 */
export const calculateActivityProgress = (startDate, endDate) => {
  const start = parseActivityDate(startDate)
  const end = parseActivityDate(endDate)
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  if (!start || !end || end < start) {
    return { percent: 0, phase: 'unknown', daysElapsed: 0, totalDays: 0 }
  }

  const totalMs = end.getTime() - start.getTime()
  const totalDays = Math.max(1, Math.round(totalMs / (1000 * 60 * 60 * 24)) + 1)

  if (today < start) {
    return { percent: 0, phase: 'upcoming', daysElapsed: 0, totalDays }
  }

  if (today > end) {
    return { percent: 100, phase: 'ended', daysElapsed: totalDays, totalDays }
  }

  const elapsedMs = today.getTime() - start.getTime()
  const percent = Math.min(100, Math.max(0, Math.round((elapsedMs / totalMs) * 100)))
  const daysElapsed = Math.floor(elapsedMs / (1000 * 60 * 60 * 24)) + 1

  return { percent, phase: 'ongoing', daysElapsed, totalDays }
}

export const getActivityStatusBadgeClass = (status) => {
  switch (status) {
    case 'planned':
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300'
    case 'ongoing':
      return 'bg-green-100 text-green-800 dark:bg-green-900/20 dark:text-green-300'
    case 'completed':
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900/20 dark:text-blue-300'
    case 'cancelled':
      return 'bg-red-100 text-red-800 dark:bg-red-900/20 dark:text-red-300'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-300'
  }
}
